<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row
          class="container"
        >
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <dashboard-filtro-mais-vida
              :primeiro="enablePrimeiroDia"
              :ultimo="enableUltimoDia"
              :empresas="enableEmpresa"
              :empresas1="enableEmpresa"
              :url="link"
              :clientes="enableClientes"
              :cidades="enableCidades"
              :cidades1="enableCidades"
              :areas="enableAreas"
              :areas1="enableAreas"
              :vendedores="enableVendedores"
              :vendedores1="enableVendedores"
              :redes="enableRedes"
              :redes1="enableRedes"
              :produtos="enableProdutos"
              :produtos1="enableProdutos"
              :linhas="enableLinhas"
              :btn1="enableBtn"
              :btn2="disableBtn"
              :caixas="enableCaixas"
              :caixas1="enableCaixas"
              :enable-datas="enableDatas"
              :enable-datas1="enableDatas"
              :filtro-completo="enableFiltro"
              :segmentos="enableSegmento"
              :segmentos1="enableSegmento"
            />
          </v-col>
        </v-row>
        <v-container>
          <v-row
            v-if="enableBtnPrint"
            id="btnPrint"
          >
            <v-btn
              class="col-4 col-sm-3 col-md-1 col-lg-1"
              small
              :color="corPrimaria"
              dark
              :loading="imprimindo"
              @click="imprimir()"
            >
              <v-icon>
                mdi-printer
              </v-icon>
              Imprimir
              <template v-slot:loader>
                <span>Imprimindo...</span>
              </template>
            </v-btn>
          </v-row>
        </v-container>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="12"
          >
            <v-card
              id="cardDashbord"
              class="mx-auto"
              outlined
            >
              <div class="card-header-dashbord">
                <v-row>
                  <v-col
                    cols="12"
                    sm="10"
                    md="10"
                    lg="10"
                    class="d-flex flex-wrap"
                  >
                    Preço Médio Venda
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    md="2"
                    lg="2"
                    class="d-flex justify-end"
                  >
                    <v-tooltip
                      top
                      max-width="400"
                      width="400"
                    >
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-icon
                          id="iconInformationClientesParcipantes"
                          class="text-left"
                          v-bind="attrs"
                          v-on="on"
                          @mouseover="enableTexto('228')"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div
                        v-if="!carregandoTooltip"
                        v-html="textoOrientacao"
                      />
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                  >
                    <dashboard-tabela-comparativo-preco-medio id="componentePrecoMedio" />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'PageMaisVidaDashvoard',
    emits: ['updateFormMaisVida', 'updateFormMaisVida2', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroMaisVida: () => import('../../components/core/FiltrosMaisVida'),
      DashboardTabelaComparativoPrecoMedio: () => import('../../components/comercial/ComparativoPrecoMedio'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      link: window.location.href,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dataInicial2: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal2: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      empresa: [],
      clientes: [],
      cidades: [],
      areas: [],
      vendedores: [],
      redes: [],
      produtos: [],
      caixas: [],
      select2: [],
      empresa2: [],
      clientes2: [],
      cidades2: [],
      areas2: [],
      vendedores2: [],
      redes2: [],
      produtos2: [],
      caixas2: [],
      segmento: [],
      segmento1: [],
      paginaEnable: true,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      disablePrimeiroDia: false,
      disableUltimoDia: false,
      enableEmpresa: true,
      enableClientes: false,
      enableCidades: true,
      enableAreas: true,
      enableVendedores: true,
      enableRedes: true,
      enableProdutos: true,
      enableLinhas: false,
      enableSegmento: true,
      enableBtn: true,
      disableBtn: false,
      enableCaixas: true,
      enableDatas: true,
      disableDatas: false,
      enableFiltro: true,
      clienteTotal: 0,
      codigo: 0,
      orientacao: [],
      textoPrecoMedio: '',
      codigoIds: ['228'],
      dynamicPaddingPrecoMedio: '',
      enableBtnPrint: false,
      imprimindo: false,
      headersComparativoTabelas: [
        { text: 'Produtos', value: 'produto', align: 'left', class: 'black--text title' },
        { text: 'Variação', value: 'variacao', align: 'right', class: 'black--text title' },
        { text: 'Percentual', value: 'percentual', align: 'right', class: 'black--text title' },
        { text: 'Preço Médio', value: 'precoMedio', align: 'right', class: 'black--text title' },
        { text: 'Diferença Tabela 2', value: 'diferencaPreco', align: 'right', class: 'black--text title' },
      ],
      headersPrecoMedio: [
        { text: 'Produtos', value: 'produto', align: 'left', class: 'black--text title' },
        { text: 'Variação', value: 'variacao', align: 'right', class: 'black--text title' },
        { text: 'Percentual', value: 'percentual', align: 'right', class: 'black--text title' },
        { text: 'Preço Médio', value: 'precoMedio', align: 'right', class: 'black--text title' },
      ],
      dadosComparativoTabelas: [],
      dadosPrecoMedio: [],
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('update-dados-mais-vida', this.handleUpdateDados)

      eventEmit.$on('set-dados-preco-medio', this.handleDadosPrecoMedio)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-mais-vida', this.handleUpdateDados)

      eventEmit.$off('set-dados-preco-medio', this.handleDadosPrecoMedio)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Preço Médio')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1380) {
          this.dynamicPaddingPrecoMedio = 'padding-right: 117rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingPrecoMedio = 'padding-right: 18rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingPrecoMedio = 'padding-right: 40rem !important'
        } else {
          this.dynamicPaddingPrecoMedio = 'padding-right: 75rem !important'
        }
      },

      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, redeSelect, vendedorSelect, produtoSelect, linhaSelect, clienteSelect, caixaSelect, tipoDevolucao, motivoDevolucao, dataInicial1, dataFinal1, empresaSelect1, cidadeSelect1, areaSelect1, redeSelect1, vendedorSelect1, produtoSelect1, linhaSelect1, clienteSelect1, caixaSelect1, receita, segmento, segmento1) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.select = empresaSelect
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.redes = redeSelect
        this.vendedores = vendedorSelect
        this.produtos = produtoSelect
        this.clientes = clienteSelect
        this.caixas = caixaSelect
        this.dataInicial2 = dataInicial1
        this.dataFinal2 = dataFinal1
        this.select2 = empresaSelect1
        this.cidades2 = cidadeSelect1
        this.areas2 = areaSelect1
        this.redes2 = redeSelect1
        this.vendedores2 = vendedorSelect1
        this.produtos2 = produtoSelect1
        this.clientes2 = clienteSelect1
        this.caixas2 = caixaSelect1
        this.segmento = segmento
        this.segmento1 = segmento1

        this.updateDados()
      },

      handleDadosPrecoMedio (dadosComparativos, dadosPrecoMedio) {
        this.enableBtnPrint = true

        this.dadosComparativoTabelas = dadosComparativos

        this.dadosPrecoMedio = dadosPrecoMedio
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      updateDados () {
        eventEmit.$emit('update-form-mais-vida', this.dataInicial, this.dataFinal, this.select, this.cidades, this.areas, this.vendedores, this.redes, this.produtos, this.linhas, this.clientes, this.caixas, this.dataInicial2, this.dataFinal2, this.select2, this.cidades2, this.areas2, this.vendedores2, this.redes2, this.produtos2, this.linhas2, this.clientes2, this.caixas2, this.segmento, this.segmento1)
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')
          let posYFiltros = 10

          const filtro = 'Filtros selecionados tabela 1'
          pdf.text(filtro, 105, posYFiltros)

          const dataInicial = this.dataInicial.substr(8) + '/' + this.dataInicial.substr(5, 2) + '/' + this.dataInicial.substr(0, 4)
          const ultimoDia = this.dataFinal.substr(8) + '/' + this.dataFinal.substr(5, 2) + '/' + this.dataFinal.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Cidade(s) Selecionada(s):', this.cidades.map(e => e.cidade))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areas.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedores.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Produto(s) Selecionado(s):', this.produtos.map(p => p.produto))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Caixa(s) Selecionada(s):', this.caixas.map(c => c.caixa))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))

          if (posYFiltros > 150) {
            pdf.addPage()

            posYFiltros = 10
          }

          const title = 'Tabela 1'
          pdf.text(title, 15, posYFiltros)

          posYFiltros += 5

          const dadosComparativoTabelas = this.dadosComparativoTabelas.map(item => [
            item.produto,
            this.getVariacao(item.variacao),
            this.getPercentual(item.percentual),
            item.precoMedio,
            this.getVariacao(item.diferencaPreco),
          ])

          pdf.autoTable({
            head: [this.headersComparativoTabelas.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
            body: dadosComparativoTabelas.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
            startY: posYFiltros,
            styles: { fontSize: 10 },
          })

          pdf.addPage()

          posYFiltros = 10

          const filtro1 = 'Filtros selecionados tabela 2'
          pdf.setFontSize(16)
          pdf.text(filtro1, 105, posYFiltros)

          const dataInicial1 = this.dataInicial2.substr(8) + '/' + this.dataInicial2.substr(5, 2) + '/' + this.dataInicial2.substr(0, 4)
          const ultimoDia1 = this.dataFinal2.substr(8) + '/' + this.dataFinal2.substr(5, 2) + '/' + this.dataFinal2.substr(0, 4)

          const datas1 = 'Data inicial: ' + dataInicial1 + ' - Data final: ' + ultimoDia1
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas1, 15, posYFiltros)

          posYFiltros += 10

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select2.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Cidade(s) Selecionada(s):', this.cidades2.map(e => e.cidade))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areas2.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedores2.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes2.map(r => r.rede))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Produto(s) Selecionado(s):', this.produtos2.map(p => p.produto))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Caixa(s) Selecionada(s):', this.caixas.map(c => c.caixa))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmento1.map(se => se.segmento))

          if (posYFiltros > 150) {
            pdf.addPage()

            posYFiltros = 10
          }

          const title2 = 'Tabela 2'
          pdf.text(title2, 15, posYFiltros)

          posYFiltros += 5

          const dadosPrecoMedio = this.dadosPrecoMedio.map(item => [
            item.produto,
            this.getVariacao(item.variacao),
            this.getPercentual(item.percentual),
            item.precoMedio,
          ])

          pdf.autoTable({
            head: [this.headersPrecoMedio.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
            body: dadosPrecoMedio.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
            startY: posYFiltros,
            styles: { fontSize: 10 },
          })

          pdf.save('relatorio_preco_medio.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.dadosComparativoTabelas = []

          this.dadosPrecoMedio = []

          this.imprimindo = false
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      getVariacao (value) {
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      },

      getPercentual (value) {
        if (value !== '-') {
          return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
        }

        return '-'
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  #componentePrecoMedio {
    margin: -4rem 0 0 0
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {

  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  @media screen
  and (min-width: 1380px) {

  }
</style>

<style lang="sass">

  #clienteTempo
    max-width: 1800px !important

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemPrecoMedio
    margin: -2rem 0 0 -1rem

</style>
